/********************************************
 * COOKIES
 ********************************************/
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function setCookieLaw() {
    closeCookies();
    setCookie('cookie_agreement', "YES", 1000);
    var ga_id = $('#div-cookie input').val();
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', ga_id);
}

function closeCookies() {
    $("#div-cookie").fadeOut('fast', function () {});
}

$("#span-cookies-agree").click(function () {
    setCookieLaw();
});